export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/stars_icon_animated.9594fcc.gif";